import { GeschaedigtesGeraet } from '@gsm/entities';
import { DYNAMIC_FORM_CONTROL_INPUT_TYPE_NUMBER, DYNAMIC_FORM_CONTROL_TYPE_GROUP, DYNAMIC_FORM_CONTROL_TYPE_INPUT, DYNAMIC_FORM_CONTROL_TYPE_SELECT, MATCH_VISIBLE } from '@ng-dynamic-forms/core';
import { TYPE_CUSTOM_FILE_UPLOAD } from '../custom-file-upload/custom-file-upload.model';
import { AnyFormControlModel } from '../shared-models/any-form-control.model';

export const OPTION_ERFASSEN = {
  label: 'Ja, Gerät/Sache erfassen',
  value: 'E'
};
export const OPTION_NACHGEBRACHT = {
  label: 'Nein, Details zum Gerät/zur Sache werden nachgebracht',
  value: 'N'
};
export const OPTION_WERT_NACHWEIS = {
  label: 'Nachweis über Besitz- /Anschaffungswert',
  value: 'W'
};
export const OPTION_TYPENSCHILD_FOTO = {
  label: 'Foto des Typenschildes',
  value: 'T'
};
export const OPTION_DETAILLIERTE_INFO = {
  label: 'Detaillierte Informationen',
  value: 'D'
};

export function GESCHAEDIGTES_GERAET_KOMPLEX_TEMPLATE_FACTORY(geschaedigtesGeraet: GeschaedigtesGeraet): AnyFormControlModel[] {
  const {
    id,
    status,
    art,
    marke,
    weitereInformationen,
    fileList,
    baujahr,
    typenbezeichnung,
    seriennummer,
    anschaffungspreis,
    kostenReperaturNeuanschaffung
  } = geschaedigtesGeraet || {};

  const currentYear = new Date().getFullYear();

  return [
    {
      id:         'id',
      type:       DYNAMIC_FORM_CONTROL_TYPE_INPUT,
      hidden:     true,
      additional: {
        forceLog: true
      },
      value:      id
    },
    {
      id:       'status',
      type:     DYNAMIC_FORM_CONTROL_TYPE_SELECT,
      label:    'Details vorhanden',
      required: true,
      options:  [
        OPTION_ERFASSEN,
        OPTION_NACHGEBRACHT
      ],
      value:    status
    },
    {
      id:        'details',
      type:      DYNAMIC_FORM_CONTROL_TYPE_GROUP,
      relations: [
        {
          match: MATCH_VISIBLE,
          when:  [
            {
              id:    'status',
              value: 'E'
            }
          ]
        }
      ],
      group:     [
        {
          id:            'art',
          type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
          label:         'Art',
          placeholder:   'Bitte geben Sie die Art an.',
          required:      true,
          validators:    {
            alphanum:  null,
            minLength: 2,
            maxLength: 300
          },
          errorMessages: {
            alphanum:  'Bitte geben Sie eine gültige {{label}} ein.',
            minLength: 'Bitte geben Sie mindestens 2 Zeichen ein.',
            maxLength: 'Bitte geben Sie maximal 300 Zeichen ein.'
          },
          value:         art
        },
        {
          id:            'marke',
          type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
          label:         'Marke',
          placeholder:   'Bitte geben Sie die Marke an.',
          validators:    {
            alphanum:  null,
            minLength: 2,
            maxLength: 300
          },
          errorMessages: {
            alphanum:  'Bitte geben Sie eine gültige {{label}} ein.',
            minLength: 'Bitte geben Sie mindestens 2 Zeichen ein.',
            maxLength: 'Bitte geben Sie maximal 300 Zeichen ein.'
          },
          value:         marke
        },
        {
          id:       'weitereInformationen',
          type:     DYNAMIC_FORM_CONTROL_TYPE_SELECT,
          label:    'Detaillierte Informationen',
          required: true,
          options:  [
            OPTION_WERT_NACHWEIS,
            OPTION_TYPENSCHILD_FOTO,
            OPTION_DETAILLIERTE_INFO
          ],
          value:    weitereInformationen
        },
        {
          id:           'fileList',
          type:         TYPE_CUSTOM_FILE_UPLOAD,
          labelTooltip: 'Dokument hinzufügen',
          required:     true,
          value:        fileList,
          relations:    [
            {
              match: MATCH_VISIBLE,
              when:  [
                {
                  id:    'weitereInformationen',
                  value: 'W'
                },
                {
                  id:    'weitereInformationen',
                  value: 'T'
                }
              ]
            }
          ]
        },
        {
          id:        'detaillierteInformationen',
          type:      DYNAMIC_FORM_CONTROL_TYPE_GROUP,
          relations: [
            {
              match: MATCH_VISIBLE,
              when:  [
                {
                  id:    'weitereInformationen',
                  value: 'D'
                }
              ]
            }
          ],
          group:     [
            {
              id:            'baujahr',
              type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
              label:         'Baujahr',
              placeholder:   'Bitte geben Sie das Baujahr an.',
              required:      true,
              inputType:     DYNAMIC_FORM_CONTROL_INPUT_TYPE_NUMBER,
              step:          1,
              min:           1900,
              max:           currentYear,
              validators:    {
                min: 1900,
                max: currentYear
              },
              errorMessages: {
                min: `Bitte geben Sie ein Baujahr zwischen 1900 und ${currentYear} ein.`,
                max: `Bitte geben Sie ein Baujahr zwischen 1900 und ${currentYear} ein.`
              },
              value:         baujahr
            },
            {
              id:            'typenbezeichnung',
              type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
              label:         'Typenbezeichnung',
              placeholder:   'Bitte geben Sie die Typenbezeichnung an.',
              validators:    {
                minLength: 2,
                maxLength: 300
              },
              errorMessages: {
                minLength: 'Bitte geben Sie mindestens 2 Zeichen ein.',
                maxLength: 'Bitte geben Sie maximal 300 Zeichen ein.'
              },
              value:         typenbezeichnung
            },
            {
              id:            'seriennummer',
              type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
              label:         'Seriennummer',
              placeholder:   'Bitte geben Sie die Seriennummer an.',
              validators:    {
                minLength: 2,
                maxLength: 300
              },
              errorMessages: {
                minLength: 'Bitte geben Sie mindestens 2 Zeichen ein.',
                maxLength: 'Bitte geben Sie maximal 300 Zeichen ein.'
              },
              value:         seriennummer
            },
            {
              id:            'anschaffungspreis',
              type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
              label:         'Ursprünglicher Anschaffungspreis',
              placeholder:   'Bitte geben Sie den Ursprünglicher Anschaffungspreis an.',
              prefix:        '€&#160;',
              required:      true,
              inputType:     DYNAMIC_FORM_CONTROL_INPUT_TYPE_NUMBER,
              min:           0,
              step:          0.01,
              validators:    {
                min:       0,
                maxLength: 15
              },
              errorMessages: {
                min:       'Bitte geben Sie eine positive Zahl ein.',
                maxLength: 'Bitte geben Sie maximal 15 Zeichen ein.'
              },
              value:         anschaffungspreis
            },
            {
              id:            'kostenReperaturNeuanschaffung',
              type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
              label:         'Kosten der Reparatur / Neuanschaffung eines gleichwertigen Geräts',
              placeholder:   'Bitte geben Sie den Kosten der Reparatur / Neuanschaffung eines gleichwertigen Geräts an.',
              prefix:        '€&#160;',
              inputType:     DYNAMIC_FORM_CONTROL_INPUT_TYPE_NUMBER,
              min:           0,
              step:          0.01,
              validators:    {
                min:       0,
                maxLength: 300
              },
              errorMessages: {
                min:       'Bitte geben Sie eine positive Zahl ein.',
                maxLength: 'Bitte geben Sie maximal 300 Zeichen ein.'
              },
              value:         kostenReperaturNeuanschaffung
            }
          ]
        }
      ]
    }
  ];
}
